import Dialog, { IConfig as IConfigDialog } from './Dialog';
import Toast, { IConfig as IConfigToast } from './Toast';
import Root from './Root';

export type { IConfigDialog, IConfigToast };
export { Dialog, Toast, Root };
